/*
 * @Author: 史金波
 * @Date: 2021-12-14 09:04:18
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-16 15:54:23
 * @FilePath: \saas-perform-web\src\api\recharge\rechargeApi.js
 */
import {httpPost,httpGet,baseUrl} from "../axiosFun.js"

//let baseUrl = "http://distribute.cloudjoys.com:8030/saasPerform"

export function searchDistributesApi(){
	return httpGet(baseUrl + "/distribution/searchAll")
}

export function submitRechargeOrderApi(data){
	return httpPost(baseUrl + "/recharge/submitOrder",data)
}

export function searchOrderApi(data){
	return httpPost(baseUrl + "/recharge/orders",data)
}


export function ordersManagerApi(data){
	return httpPost(baseUrl + "/recharge/ordersManager",data)
}

export function searchDetailApi(data){
	return httpGet(baseUrl + "/recharge/orderDetail?orderId=" + data)
}

export function authPassApi(data){
	return httpGet(baseUrl + "/recharge/authPass?orderId=" + data)
}

export function authRejectApi(data){
	return httpGet(baseUrl + "/recharge/authReject?orderId=" + data)
}

export function searchOrdersListApi(data){
	return httpPost(baseUrl + "/accountOrder/mechantSearch",data)
}

export function searchAccountAmountInfo(){
	return httpGet(baseUrl + "/account/accountSearch")
}


// WEBPACK FOOTER //
// ./src/api/recharge/rechargeApi.js